module.exports = __webpack_public_path__ + "img/tank-base-shadow-1.f3c6806f.png";